module.exports = __webpack_public_path__ + "static/media/cctv1.f179c4ac.png";